import { useRef } from "react";
import classNames from "classnames";
import { useOnClickOutside } from 'shared/hooks';
import "./styles.scss";
import { observer } from 'mobx-react';

type Props = {
    items?: { id: string | number; name: string }[];
    value?: string | number | null;
    current?: { id: string | number; name: string } | null;
    isOpen?: boolean;
    onToggle?: () => void;
    onClose?: () => void;
    onSelect?: (id: string | number) => void;
};

export const PPDWidgetGroupSelectDropdown = observer(({
    items = [],
    value = null,
    current = null,
    isOpen = false,
    onToggle = () => {},
    onClose = () => {},
    onSelect = () => {},
}: Props) => {
    const ref = useRef<HTMLDivElement>(null);
    useOnClickOutside(ref, onClose);

    if (!items.length) return null;

    return (
        <div className="ppd-widget-group-select-dropdown" ref={ref}>
            <button
                type="button"
                className={classNames("ppd-widget-group-select-dropdown__button", {
                    "ppd-widget-group-select-dropdown__button--open": isOpen,
                })}
                onClick={onToggle}
            >
                <span>{current?.name ?? ""}</span>
            </button>

            {isOpen && (
                <div className="ppd-widget-group-select-dropdown__dropdown">
                    <div className="ppd-widget-group-select-dropdown__options">
                        {items.map(g => (
                            <div
                                key={g.id}
                                className={classNames("ppd-widget-group-select-dropdown__option", {
                                    "ppd-widget-group-select-dropdown__option--active": g.id === value,
                                })}
                                onClick={() => onSelect(g.id)}
                            >
                                {g.name}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
});
